/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ContactInfoCategory {
    Unknown = 'Unknown',
    Office = 'Office',
    Home = 'Home',
    Mobile = 'Mobile'
}

export function ContactInfoCategoryFromJSON(json: any): ContactInfoCategory {
    return ContactInfoCategoryFromJSONTyped(json, false);
}

export function ContactInfoCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactInfoCategory {
    return json as ContactInfoCategory;
}

export function ContactInfoCategoryToJSON(value?: ContactInfoCategory | null): any {
    return value as any;
}

